export default "/images/0bc006684d342b433346d8a8bd5e0aaf.avif";